<div class="container">
    <h1 jhitranslate="locations.title">
        <i class="fa fa-industry fa-pre" aria-hidden="true"></i>
        {{ 'locations.title' | translate }}
    </h1>

    <div class="filters-parent">
        <div class="filters">
            <label class="control-label" for="search">{{
                'locations.search' | translate
            }}</label>
            <input
                class="form-control input-filter"
                id="search"
                type="text"
                [(ngModel)]="search"
                [placeholder]="'locations.filterBy' | translate"
                #searchInput
            />
        </div>
    </div>

    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th style="width: 30%;">
                        {{ 'locations.name' | translate }}
                    </th>
                    <th style="width: 30%;">
                        {{ 'locations.address' | translate }}
                    </th>
                    <th style="width: 15%">
                        {{ 'locations.zipCode' | translate }}
                    </th>
                    <th style="width: 25%">
                        {{ 'locations.city' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let location of locations | filterByName: search">
                    <td>
                        <a
                            uiSref="location-detail"
                            [uiParams]="{ id: location.id }"
                        >
                            {{ location.name }}
                        </a>
                    </td>
                    <td>
                        <a
                            uiSref="location-detail"
                            [uiParams]="{ id: location.id }"
                        >
                            {{ location.address1 }}
                        </a>
                    </td>
                    <td>
                        <a
                            uiSref="location-detail"
                            [uiParams]="{ id: location.id }"
                        >
                            {{ location.zipCode }}
                        </a>
                    </td>
                    <td>
                        <a
                            uiSref="location-detail"
                            [uiParams]="{ id: location.id }"
                        >
                            {{ location.city }}
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <button class="btn btn-primary btn-round btn-lg" uiSref="location-create">
        +
    </button>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/location/location.component.html